import { Component, OnInit, OnDestroy } from '@angular/core';
import { PaymentGatewayService, DialogService, SEOService } from '@box-core/services';
import { Card, APIError, SeoOptions } from '@box-types';
import { finalize, map, tap, catchError } from 'rxjs/operators';
import { Subscription, of } from 'rxjs';
import { environment } from '@box-env/environment';
import { deleteJsonLd } from '@box/utils';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'account-cards',
  templateUrl: './account-cards.page.html',
  styleUrls: ['./account-cards.page.scss']
})
export class AccountCardsPage implements OnInit, OnDestroy {
  public cards: Card[] = [];
  public hasCards: boolean;
  public loading = true;

  private cardsSubscription: Subscription;

  constructor(
    private paymentGatewayService: PaymentGatewayService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setCardsSubscription();
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    if (this.cardsSubscription) this.cardsSubscription.unsubscribe();
    deleteJsonLd();
  }

  public onEditCard(): void {
    const cosmoteID: string = environment.cosmote.ACCOUNT_URL;
    window.location.href = cosmoteID + '/profile';
  }

  private setCardsSubscription(): void {
    const cards$ = this.paymentGatewayService.fetchPaymentGatewayInfo().pipe(
      tap((response) => this.paymentGatewayService.setPaymentGatewayInfo(response)),
      map((info) => info?.cardList),
      catchError((error: APIError) => {
        this.dialogService.openErrorDialog(error);
        return of([] as Card[]);
      })
    );

    this.loading = true;
    this.cardsSubscription = cards$.pipe(finalize(() => (this.loading = false))).subscribe((response: Card[]) => {
      this.cards = response;
      this.hasCards = this.cards?.length > 0;
    });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
